import Icon from '../components/Icon.vue'

Icon.register({
  dice: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M592 192c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-224c-26.5 0-48-21.5-48-48v-46.4l136.3-136.3c24.1-24.1 29.7-59.7 17-89.3h118.7zM480 376c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24zM433.6 189.3c19.2 19.2 19.2 50.2 0 69.4l-174.9 174.9c-19.2 19.2-50.2 19.2-69.4 0l-174.9-174.9c-19.2-19.2-19.2-50.2 0-69.4l174.9-174.9c19.2-19.2 50.2-19.2 69.4 0zM96 248c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24zM224 376c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24zM224 248c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24zM224 120c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24zM352 248c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24z'
      }
    ]
  }
})
